/**
 * @author NikolaV
 */
import { isCluster, latLonToEN } from '../ol-utils';
import { FeatureMouseInteraction } from '../interaction/FeatureMouseInteraction';
import Feature, { FeatureLike } from 'ol/Feature';

import { Point as OlPoint } from 'ol/geom';
import * as olStyle from 'ol/style';
import { SvgIconsToPng } from '@shared/map/MapIcons';
import { CanvasUtils } from '@shared/utils/CanvasUtils';


const svgs = {
    pdf: makeSvgPdfIcon(),
    file: makeSvgFileIcon(),
    doc: makeSvgDocIcon('DOC', '#154696'),
    xls: makeSvgDocIcon('XLS', '#84bd5a', 1),
}

const pngs = {
    pdf: null,
    file: null,
    doc: null,
    xls: null
};

let groupImg = null;

// we can't use svg for icons in openlayers, big performance hit in chrome only, so we have to use pngs
const convertIcons = async () => {
    for (const [key, svg] of Object.entries(svgs)) {
        pngs[key] = await CanvasUtils.svgToPng(svg, 2);
    };

    groupImg = await CanvasUtils.makeImage(await CanvasUtils.svgToPng(makeGroupIcon(), 2));
}
convertIcons();

function makeSvgPdfIcon(scale = 1) {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${16 * scale}" height="${20 * scale}" viewBox="0 0 500 600" xml:space="preserve"><path d="M475.3 151.1v334.6c0 53.1-43 96.1-96.1 96.1H129.1c-53.1 0-96.1-43-96.1-96.1V106.2c0-53.1 43-96.1 96.1-96.1h189.4l156.8 141z" style="fill:#fff;stroke:#ABABAB;stroke-width:30;stroke-miterlimit:10"/><path style="fill:#e6e7e8;stroke:#ABABAB;stroke-width:30;stroke-miterlimit:10" d="M474.3 152.1H317.5v-141"/><path d="M42.3 534.4c-14.2 0-25.7-7.2-30.6-19.4-8.2-20.2 3.6-47.9 32.5-76.1 22.6-22.1 54.2-40.3 93.9-54.1 21.1-39.2 40.6-81.2 54.2-117.1-30.2-47-35.8-105-25.2-137.4 6.8-21 18.7-28.8 27.4-31.8 12.2-4.1 24.6-1 33.2 8.3 13 14 17.8 42.2 14.6 86.3-1.3 17.6-7.1 41.1-17.4 70.2.4.6.9 1.1 1.4 1.7 6.9 8.4 14.2 17.6 21.8 27.2 16.3 20.6 34.7 43.8 53.4 64.5 5.5-.2 10.8-.3 16-.3 66 0 110.3 13.8 124.8 38.9 6.2 10.7 6.3 22.7.4 33-8 13.9-25.4 22.2-46.4 22.2-5.1 0-10.4-.5-15.7-1.5-26.5-4.9-55.6-24.9-91.3-62.7-9.1.5-18.7 1.2-28.4 2.2-21 2-61.6 7.3-102.6 20.2-17.7 31.9-55.7 96.4-84 114.9-10.9 7.1-21.9 10.8-32 10.8zm72.4-108.6c-20.3 9.8-37.1 21.2-50.2 33.9-25.7 25.1-27.3 40.8-25.9 44.3.4 1 2.2 1.2 3.6 1.2 4.3 0 10.2-2.2 15.9-5.9 12.8-8.3 33.7-35.8 56.6-73.5zm215.2-40c22 20.4 40.4 31.8 56 34.6 3.6.7 7 1 10.4 1 11.5 0 19.1-4 21.2-7.6.4-.7.9-1.6-.4-3.9-5-8.5-28.8-22.4-87.2-24.1zm-117-91c-10.2 25-22.5 52-36 78.6 33.4-8.3 63.6-12.1 81.1-13.8 2.3-.2 4.5-.4 6.8-.6-13.9-16.4-27.2-33.2-39.5-48.6-4.2-5.4-8.4-10.6-12.4-15.6zm-7.7-168.9c-.2 0-.7 0-1.4.3-3.3 1.1-6.6 6-9 13.2-7 21.4-4.2 57.5 10.3 90.7 4.6-15.7 7.4-29 8.1-39.1 3.6-49-4.4-61.7-6.9-64.4-.6-.7-.9-.7-1.1-.7z" style="fill:#ee3e36"/></svg>`
}

function makeSvgFileIcon(scale = 1) {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${16 * scale}" height="${20 * scale}" viewBox="0 0 500 600" xml:space="preserve"><path d="M475.3 151.1v334.6c0 53.1-43 96.1-96.1 96.1H129.1c-53.1 0-96.1-43-96.1-96.1V106.2c0-53.1 43-96.1 96.1-96.1h189.4l156.8 141z" style="fill:#fff;stroke:#ABABAB;stroke-width:30;stroke-miterlimit:10"/><path style="fill:#e6e7e8;stroke:#ABABAB;stroke-width:30;stroke-miterlimit:10" d="M474.3 152.1H317.5v-141"/></svg>`
}

function makeSvgDocIcon(text: string, color: string, scale = 1) {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${16 * scale}" height="${20 * scale}" viewBox="0 0 500 600" xml:space="preserve"><path d="M475.3 151.1v334.6c0 53.1-43 96.1-96.1 96.1H129.1c-53.1 0-96.1-43-96.1-96.1V106.2c0-53.1 43-96.1 96.1-96.1h189.4l156.8 141z" style="fill:#fff;stroke:#ABABAB;stroke-width:30;stroke-miterlimit:10"/><path d="M399.2 491H59.7c-13.8 0-25-11.2-25-25V308.5c0-13.8 11.2-25 25-25h339.5c13.8 0 25 11.2 25 25V466c0 13.8-11.2 25-25 25z" style="fill:#e6e7e8"/><path style="fill:#e6e7e8;stroke:#ABABAB;stroke-width:30;stroke-miterlimit:10" d="M474.3 152.1H317.5v-141"/><path d="M382.5 474.4H34c-13.8 0-25-11.2-25-25V291.9c0-13.8 11.2-25 25-25h348.5c13.8 0 25 11.2 25 25v157.6c0 13.7-11.2 24.9-25 24.9z" style="fill:${color};stroke:#ABABAB;stroke-width:30;stroke-miterlimit:10"/><text transform="translate(37.952 436.7683)" style="font-size:160px;font-family:'Arial';fill:#fff">${text}</text></svg>`
}

function makeGroupIcon(count = 1) {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 800 800" xml:space="preserve"><circle style="fill:#e7ebec;stroke:#ABABAB;stroke-width:30;stroke-miterlimit:10" cx="374.3" cy="376" r="364.7"/><path style="fill:#fff;stroke:#ABABAB;stroke-width:30;stroke-miterlimit:10" d="M318.1 142.8v210.4c0 33.4-27 60.4-60.4 60.4H100.4c-33.4 0-60.4-27-60.4-60.4V114.5c0-33.4 27-60.4 60.4-60.4h119.1l98.6 88.7z"/><path style="fill:#e6e7e8;stroke:#ABABAB;stroke-width:30;stroke-miterlimit:10" d="M317.5 143.4h-98.6V54.7"/><path style="fill:#fff;stroke:#ABABAB;stroke-width:30;stroke-miterlimit:10" d="M507.7 228.5v243.2c0 38.6-31.3 69.9-69.9 69.9H256c-38.6 0-69.9-31.3-69.9-69.9V195.8c0-38.6 31.3-69.9 69.9-69.9h137.7l114 102.6z"/><path style="fill:#e6e7e8;stroke:#ABABAB;stroke-width:30;stroke-miterlimit:10" d="M507 229.2H393V126.7"/><path style="fill:#fff;stroke:#ABABAB;stroke-width:30;stroke-miterlimit:10" d="M715.4 335.2v292.6c0 46.4-37.6 84-84 84H412.7c-46.4 0-84-37.6-84-84V295.9c0-46.4 37.6-84 84-84h165.6l137.1 123.3z"/><path style="fill:#e6e7e8;stroke:#ABABAB;stroke-width:30;stroke-miterlimit:10" d="M714.5 336.1H577.4V212.8"/><path style="fill:#ee3e36" d="M336.8 670.4c-12.4 0-22.5-6.3-26.8-17-7.2-17.7 3.1-41.9 28.4-66.5 19.8-19.3 47.4-35.2 82.1-47.3 18.5-34.3 35.5-71 47.4-102.4-26.4-41.1-31.3-91.8-22-120.1 5.9-18.4 16.4-25.2 24-27.8 10.7-3.6 21.5-.9 29 7.3 11.4 12.2 15.6 36.9 12.8 75.5-1.1 15.4-6.2 35.9-15.2 61.4.3.5.8 1 1.2 1.5 6 7.3 12.4 15.4 19.1 23.8 14.3 18 30.3 38.3 46.7 56.4 4.8-.2 9.4-.3 14-.3 57.7 0 96.4 12.1 109.1 34 5.4 9.4 5.5 19.8.3 28.9-7 12.2-22.2 19.4-40.6 19.4-4.5 0-9.1-.4-13.7-1.3-23.2-4.3-48.6-21.8-79.8-54.8-8 .4-16.4 1-24.8 1.9-18.4 1.7-53.9 6.4-89.7 17.7-15.5 27.9-48.7 84.3-73.5 100.5-9.6 5.9-19.2 9.2-28 9.2zm63.3-95c-17.8 8.6-32.4 18.5-43.9 29.6-22.5 21.9-23.9 35.7-22.6 38.7.3.9 1.9 1 3.1 1 3.8 0 8.9-1.9 13.9-5.2 11.2-7.1 29.5-31.1 49.5-64.1zm188.2-35c19.2 17.8 35.3 27.8 49 30.3 3.1.6 6.1.9 9.1.9 10.1 0 16.7-3.5 18.5-6.6.3-.6.8-1.4-.3-3.4-4.4-7.5-25.3-19.7-76.3-21.2zM486 460.8c-8.9 21.9-19.7 45.5-31.5 68.7 29.2-7.3 55.6-10.6 70.9-12.1 2-.2 3.9-.3 5.9-.5-12.2-14.3-23.8-29-34.5-42.5-3.7-4.6-7.3-9.2-10.8-13.6zm-6.8-147.7c-.2 0-.6 0-1.2.3-2.9 1-5.8 5.2-7.9 11.5-6.1 18.7-3.7 50.3 9 79.3 4-13.7 6.5-25.4 7.1-34.2 3.1-42.8-3.8-54-6-56.3-.5-.6-.8-.6-1-.6z"/></svg>`;
}

const FEATURE_TYPE = 'document';

const groupStyleCache = {}; // cluster icons
const singleIconCache = {}; // normal image icons

const styles = {
    hidden: new olStyle.Style({
        image: new olStyle.Circle({
            fill: new olStyle.Fill({
                color: [0, 0, 0, 0.005],
            }),
            radius: 15,
        }),
    }),
};

function styleFunction(feature: FeatureLike, iconScale = 1) {
    if (isCluster(feature)) { // is a cluster
        const feature0 = feature.get('features')[0];
        const data = feature0.get('data');
        if (data.geographicPoint.lat == 0 && data.geographicPoint.lon == 0) {
            return null;
        }
        const count = feature.get('features').length;
        return [renderGroupStyle(count, iconScale)];
    }
    else {
        feature = feature.get('features')[0]; // single feature is also a cluster just with one feature in it
        const data: IDocument = feature.get('data');

        if (data.geographicPoint.lat == 0 && data.geographicPoint.lon == 0) {
            return null;
        }
        return [styles.hidden, renderSingleIcon(utils.getExtensionFromFilename(data.name), iconScale, data.icon)];
    }
}

// renders group icon + count
function renderGroupStyle(count: number = 0, iconScale = 1) {
    const cacheKey = count + String(iconScale);
    if (groupStyleCache[cacheKey]) return groupStyleCache[cacheKey];

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = groupImg.width;
    canvas.height = groupImg.height;
    ctx.drawImage(groupImg, 0, 0);
    ctx.font = '30px Arial';
    ctx.lineWidth = 3;
    ctx.strokeStyle = '#FFFFFF';
    ctx.fillStyle = '#000000';
    const text = count.toString();
    const x = 0;
    const y = groupImg.height - 5;
    ctx.strokeText(text, x, y);
    ctx.fillText(text, x, y);

    const style = new olStyle.Style({
        image: new olStyle.Icon({
            src: canvas.toDataURL('image/png'),
            scale: iconScale * 0.5
        })
    });

    groupStyleCache[cacheKey] = style;
    return style;
}

// renders image icon
function renderSingleIcon(ext: string, iconScale = 1, icon: string) {
    const cacheKey = ext + String(iconScale) + icon;
    if (singleIconCache[cacheKey]) return singleIconCache[cacheKey];

    let png = null;
    if (icon) {
        png = SvgIconsToPng[icon] ? SvgIconsToPng[icon] : SvgIconsToPng.pdf
    } else {
        png = pngs.file;
        if (ext === 'doc' || ext === 'docx') {
            png = pngs.doc;
        } else if (ext === 'pdf') {
            png = pngs.pdf;
        } else if (ext === 'xls' || ext === 'xlsx') {
            png = pngs.xls;
        }
    }

    const style = new olStyle.Style({
        image: new olStyle.Icon({
            src: png,
            scale: iconScale * 0.5
        }),
    });

    singleIconCache[cacheKey] = style;
    return style;
}

function makeFeature(document: IDocument, mouseInteraction?: FeatureMouseInteraction): Feature {
    if (!document.geographicPoint) {
        return null;
    }

    const coord: Coordinate = latLonToEN(document.geographicPoint.lat, document.geographicPoint.lon);
    if (!coord) {
        return null;
    }

    const feature = new Feature({
        geometry: new OlPoint(coord),
    });
    const source: FeatureSource = {
        documentId: document.id,
    };
    if (document.folder.id) source.folderId = document.folder.id;
    if (document.id) source.documentId = document.id;

    feature.setId(document.id);
    feature.set('source', source, true);
    feature.set('data', document);
    feature.set('type', FEATURE_TYPE);
    feature.set('no_hover_style', true);
    feature.set('mouseInteraction', mouseInteraction);

    return feature;
}

export const DocumentFeatureFactory = {
    makeFeature,
    styleFunction,
    styles,
    FEATURE_TYPE,
    icons: svgs
};
